import React, { useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  valoresExibidosDenominacoes as valoresExibidos,
  headersDenominacoes,
  DenominacoesTableRow,
} from './auxiliarDenominacoesGenericas';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
//import Button from '../../../../components/Button';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomSpan from '../../../../components/CustomSpan';
import CustomTableOffcanvas from '../../../../components/CustomTableOffcanvas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { UserContext } from '../../../../modules/contexts/Auth/UserProvider';
import { useDenominacoesGenericasCache } from '../../../../services/cache/useDenominacoesGenericasCache';
import { useTipoProduto } from '../../../../services/enum/useTipoProduto';
import { formataNomeMeioSiglas, formatDate } from '../../../../utils/functions';
import SubAbas from '../subabas';
import { buildDenominacoesTableData } from './tableDenominacoes';
import DetailsTable from '../../../../components/CustomTable/DetailsTable';

//DADOS USUARIO

const DenominacoesIndex: React.FC = () => {
  const { cudProdutoDaf } = useContext(UserContext);
  const navigate = useNavigate();
  const tipoProduto = useTipoProduto();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    tipoProduto: 0,
    dcb: '',
    denominacaoGenerica: '',
  });

  const { data } = useDenominacoesGenericasCache();

  const getTipoProdutoInfo = (item: any) => {
    const tipo = item.tipoProduto;
    if (typeof tipo === 'number' && tipoProduto?.[tipo]) {
      return tipoProduto[tipo].label;
    }
    return 'Não informado';
  };

  const tableData = buildDenominacoesTableData(data, getTipoProdutoInfo);

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    denominacaoGenerica: <b>{item.denominacaoGenerica}</b>,
    tipoProduto: tipoProduto[item.tipoProduto]?.label || 'Não informado',
    dcb: item.dcb,
    compBasico:
      item.compBasico === 'S' ? (
        <CustomSpan texto="Sim" />
      ) : (
        <CustomSpan texto="Não" />
      ),
    compEspecializado:
      item.compEspecializado === 'S' ? (
        <CustomSpan texto="Sim" />
      ) : (
        <CustomSpan texto="Não" />
      ),
    compEstrategico:
      item.compEstrategico === 'S' ? (
        <CustomSpan texto="Sim" />
      ) : (
        <CustomSpan texto="Não" />
      ),
    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  const handleClickInserir = () => {
    navigate('dadosgerais');
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    tipoProduto: number;
    denominacaoGenerica: string;
    dcb: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        tipoProduto: tipoProduto[item.tipoProduto].label,
        denominacaoGenerica: item.denominacaoGenerica,
        dcb: item.dcb,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const filteredDataForExport = data.filter((item) => {
    return (
      (formFiltros.tipoProduto === 0 ||
        String(item.tipoProduto) ===
          tipoProduto[formFiltros.tipoProduto].label) &&
      (formFiltros.dcb === '' ||
        item.dcb.toLowerCase().includes(formFiltros.dcb.toLowerCase())) &&
      (formFiltros.denominacaoGenerica === '' ||
        item.denominacaoGenerica
          .toLowerCase()
          .includes(formFiltros.denominacaoGenerica.toLowerCase()))
    );
  });

  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);
  const offcanvasOpenRoute = useMemo(() => {
    if (typeof window === 'undefined') return undefined;
    if (!selectedDetailsRowId) return undefined;
    const fichaPath = `/${selectedDetailsRowId}/dadosgerais`;
    return `${window.location.origin}/#${location.pathname}${fichaPath}`;
  }, [selectedDetailsRowId, location.pathname]);

  const handleOpenDetails = (row: DenominacoesTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const handleTableRowClick = (row: DenominacoesTableRow) => {
    if (row?.id) {
      navigate(`${row.id}/dadosgerais`);
    }
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        {/* <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="15%">
              <Select
                name="tipoProduto"
                value={formFiltros.tipoProduto}
                options={tipoProduto}
                onChange={handleChange}
                label="Tipo de Produto"
              />
            </CustomCol>
            <CustomCol width="10%">
              <Input
                id="dcb"
                name="dcb"
                value={formFiltros.dcb}
                label="DCB"
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="75%">
              <Input
                id="denominacaoGenerica"
                name="denominacaoGenerica"
                value={formFiltros.denominacaoGenerica}
                label="Denominação Genérica"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo> */}

        <CustomTableOffcanvas
          headers={headersDenominacoes}
          data={tableData}
          displayValues={valoresExibidos}
          offcanvasTitle="Denominação Genérica - Detalhes"
          widthOffcanvas="50%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          // emptyMessage="Carregando..."
          showPagination={true}
          showOpenButton={true}
          filterable={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresExibidos}
            />
          )}
        </CustomTableOffcanvas>

        {/* <Tabela
          headers={headersDenominacaoGenerica}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          tituloCanvas="DENOMINAÇÃO GENÉRICA"
        /> */}
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          // download
          // //   downloadDisabled={btDisable}
          // onClickDownload={() =>
          //   ExportToExcel(
          //     prepareDataForExport(filteredDataForExport),
          //     valoresExibidos,
          //     fieldObject,
          //     'sisaf_denominacoes_genericas.xlsx',
          //     userID,
          //     'DAF', // Nome da interface
          //     entity, // Nome da entidade
          //   )
          // }
          inserir
          inserirDisabled={!cudProdutoDaf}
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default DenominacoesIndex;
